<template>
  <div>
    <el-form inline ref="form" label-width="120px" :model="myForm" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item prop="mac">
            <el-input
              v-model="myForm.mac"
              placeholder="请输入设备MAC地址"
            ></el-input>
          </el-form-item>

          <el-form-item prop="cloud">
            <el-select
              v-model="myForm.cloud"
              placeholder="请选择云平台"
              style="width: 160px;"
            >
              <el-option
                v-for="cloud in cloudEnvList"
                :label="cloud"
                :key="cloud"
                :value="cloud"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="configType">
            <el-select v-model="myForm.configType" placeholder="请选择配置文件类型">
              <el-option
                v-for="configType in deviceConfigTypes"
                :label="configType.name"
                :key="configType.value"
                :value="configType.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button @click="onSubmit" type="primary">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div id="mask" ref="content" style="height:600px;" v-if="showEditor">
      <div class="mask"></div>
    </div>
  </div>
</template>

<script>
import { DeviceConfigTypes } from "@/components/Index/data.js";

export default {
  data() {
    return {
      dialogFormVisible: false,
      rules: {
        mac: [{required: true, message: "请输入设备MAC地址", trigger: "blur"}],
        cloud: [{required: true, message: "请选择云平台", trigger: "blur"}],
        configType: [{required: true, message: "请选择配置文件类型", trigger: "blur"}]
      },
      myForm: {
        mac: "",
        cloud: "",
        configType: "",
      },
      deviceConfigTypes: DeviceConfigTypes,
      cloudEnvList: [],
      token: "",
      editor: null,
      fileType: "plaintext",
      showEditor:true
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchCloudEnvs();
    this.initEditor();
  },
  methods: {
    initEditor(){
      this.editor = monaco.editor.create(this.$refs.content, {
        value: "",
        language: this.fileType,
        formatOnPaste: true,
        theme: "vs-dark",
        readOnly: false
      });
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        let formData = this.myForm;
        if (!valid) {
          alert("请检查输入是否正确！");
          return false;
        }

        const  deviceConfigTypesIndex = this.deviceConfigTypes.findIndex(item=>item.value===this.myForm.configType)
        this.fileType = this.deviceConfigTypes[deviceConfigTypesIndex].type

        this.dialogFormVisible = false;

        this.$http["get"](
          "device-config/",
          {
            mac: formData.mac,
            cloud: formData.cloud,
            configType: formData.configType,
          },
          data => {
            this.$baseNotice.message("查询成功");
            this.content = data.data;

            this.showEditor = false
            setTimeout(()=>{
              this.showEditor = true
              setTimeout(()=>{
                this.initEditor();
                this.editor.setValue(data.data);
                this.editor.getAction('editor.action.formatDocument').run()
                this.editor.setValue(this.editor.getValue());
              })
            }, 50)
            // console.log('this.editor.setModelLanguage',this.editor)
          }
        );
      });
    },
    fetchCloudEnvs() {
      this.$http["get"]("cloud/env/", {}, data => {
        this.cloudEnvList = data.data.results.map(item => item.cloud);
      });
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
